import React, { useState } from "react";
import Layout from "../../components/layout";
import MainBanner from "../../components/ht-case-study/page-main-banner";
import CsIntro from "../../components/ht-case-study/cs-intro";
import CsEbusiness from "../../components/ht-case-study/cs-ebusiness";
import CsOurProduct from "../../components/ht-case-study/cs-ourProducts";
import CsMobileIntro from "../../components/ht-case-study/cs-mobile-intro";
import CsServices from "../../components/ht-case-study/cs-services";
import CsCustomerRating from "../../components/ht-case-study/cs-customer-rating";
import CsImpact from "../../components/ht-case-study/cs-impact";
import SEO from '../../components/seo';
import FormSection from "../../components/common/templates/form/form-section";
import StickyCTA from "../../components/common/templates/sticky-cta-section";


function HtCaseStudy({ location }) {
  const [pageLoaded, setPageLoaded] = useState(false);
  return (
    <div onLoad={() => setPageLoaded(true)}>
      <Layout addBodyClass="ht-case-study-page-template white-header" footerFormType="basic">
        <SEO description="How we helped Harris Teeter transform grocery shopping in Charlotte, North Carolina?"
          meta={[{ name: "charSet", content: "utf-8" }]}
          title="Transforming Grocery Shopping Experiences - Harris Teeter" />
        <MainBanner />
        <CsIntro isLoaded={pageLoaded} />
        <CsEbusiness isLoaded={pageLoaded} />
        <CsOurProduct isLoaded={pageLoaded} />
        <CsMobileIntro isLoaded={pageLoaded} />
        <CsServices isLoaded={pageLoaded} />
        <CsCustomerRating isLoaded={pageLoaded} />
        <CsImpact isLoaded={pageLoaded} />
        {/*<FormSection location={location} className="site-footer-form" isLoaded={pageLoaded} />*/}
        {/* <StickyCTA /> */}
      </Layout>
    </div>
  );
}

export default HtCaseStudy;
